/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type IllegalContentReportViewContainer_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"UserBoxContainer_viewer" | "CreateCommentMutation_viewer" | "CreateCommentReplyMutation_viewer" | "IgnoredTombstoneOrHideContainer_viewer" | "CommentContainer_viewer">;
    readonly " $refType": "IllegalContentReportViewContainer_viewer";
};
export type IllegalContentReportViewContainer_viewer$data = IllegalContentReportViewContainer_viewer;
export type IllegalContentReportViewContainer_viewer$key = {
    readonly " $data"?: IllegalContentReportViewContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"IllegalContentReportViewContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IllegalContentReportViewContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBoxContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentMutation_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentReplyMutation_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '5746e7c6fad4ba11f686f3d642ec406a';
export default node;
